function cov_21b33jx18d() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Star.tsx";
  var hash = "7ed3c6f8b5bda18389569133e507b5da2f6990f1";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Star.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 44
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "7ed3c6f8b5bda18389569133e507b5da2f6990f1"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_21b33jx18d = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_21b33jx18d();
var Icon = (cov_21b33jx18d().s[0]++, {
  name: 'star',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.3789 21.9101C17.501 21.9777 17.6388 22.0082 17.7766 21.9981C17.9144 21.988 18.0468 21.9376 18.1587 21.8527C18.2705 21.7678 18.3574 21.6518 18.4095 21.5178C18.4616 21.3838 18.4769 21.2372 18.4534 21.0947L17.4257 14.8194L21.7782 10.3762C21.8765 10.2753 21.9459 10.1477 21.9787 10.0078C22.0115 9.86791 22.0063 9.7212 21.9638 9.58418C21.9213 9.44716 21.8431 9.32528 21.738 9.23226C21.633 9.13923 21.5052 9.07876 21.3691 9.05763L15.3505 8.14162L12.6616 2.43401C12.6008 2.30382 12.5063 2.19412 12.3889 2.11739C12.2715 2.04066 12.1358 2 11.9974 2C11.859 2 11.7233 2.04066 11.6059 2.11739C11.4885 2.19412 11.394 2.30382 11.3332 2.43401L8.6517 8.14162L2.63313 9.05763C2.49651 9.0784 2.36817 9.13878 2.26264 9.23197C2.15712 9.32517 2.07862 9.44744 2.03604 9.58494C1.99346 9.72243 1.98851 9.86964 2.02173 10.0099C2.05495 10.1502 2.12502 10.278 2.22401 10.3787L6.56911 14.8194L5.54137 21.0947C5.51795 21.2372 5.53316 21.3838 5.58526 21.5178C5.63736 21.6518 5.72427 21.7678 5.83615 21.8527C5.94802 21.9376 6.08038 21.988 6.2182 21.9981C6.35603 22.0082 6.49382 21.9777 6.61593 21.9101L11.9986 18.9479L17.3789 21.9101ZM15.4086 17.9714L14.754 13.9743L17.6478 11.0201L13.6568 10.4126L11.9996 6.89485L10.347 10.4124L6.34988 11.0207L9.24069 13.9751L8.58604 17.9723L11.9989 16.0942L15.4086 17.9714Z\" fill=\"currentColor\"/>"
});
export default Icon;